// test1267
(1267 && 0);
